// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bex_a"};